var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3876_10540)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 14.5V2.5C1.33333 2.32319 1.40357 2.15362 1.5286 2.0286C1.65362 1.90357 1.82319 1.83333 2 1.83333H5.33333V0.5H2C1.46957 0.5 0.960859 0.710714 0.585786 1.08579C0.210714 1.46086 0 1.96957 0 2.5L0 14.5C0 15.0304 0.210714 15.5391 0.585786 15.9142C0.960859 16.2893 1.46957 16.5 2 16.5H5.33333V15.1667H2C1.82319 15.1667 1.65362 15.0964 1.5286 14.9714C1.40357 14.8464 1.33333 14.6768 1.33333 14.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.416 7.08468L12.3587 4.02734L11.416 4.97001L14.2587 7.81268L3.33398 7.83201V9.16534L14.296 9.14601L11.4147 12.0273L12.3573 12.97L15.4147 9.91268C15.7898 9.5378 16.0006 9.02928 16.0009 8.49895C16.0011 7.96862 15.7907 7.45991 15.416 7.08468Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3876_10540"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.a1a4779743fb9ff2d55c6a95beb3ef71.svg";
export { ForwardRef as ReactComponent };